import PropTypes from 'prop-types';
import React from 'react';
import {
  Grid,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
} from '@mui/material';
import { OpenInNew, Visibility } from '@mui/icons-material';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CustomTooltip from '../../../shared/atoms/CustomTooltip';
import AssetIcon from '../../../shared/atoms/AssetIcon';
import { useGeneralContext } from '../../../../context/GeneralContext';

const LayersList = ({ list, onAction, hideDescription, splitCols }) => {
  const params = useParams();
  const { t } = useTranslation();
  const { isMapPage } = useGeneralContext();
  return (
    <Grid container padding="1rem">
      {list.map((item, idx) => (
        <Grid
          item
          xs={splitCols ? 6 : 12}
          key={item.id}
          sx={{
            borderRight: theme =>
              splitCols && idx % 2 === 0
                ? `1px solid ${theme.palette.primary.main}`
                : 'none',
            pr: splitCols && idx % 2 === 0 ? 2 : 0,
            pl: splitCols && idx % 2 === 1 ? 2 : 0,
          }}
        >
          <ListItem
            key={item.id}
            alignItems={splitCols ? 'flex-start' : null}
            sx={{
              padding: 0,
              '& .MuiListItemSecondaryAction-root': splitCols
                ? {
                    alignItems: 'flex-start',
                    top: 0,
                    transform: 'none',
                  }
                : null,
            }}
            secondaryAction={
              <Stack direction="row" marginRight="-20px">
                <CustomTooltip title={t('components.pop_up.view_details')}>
                  <IconButton
                    edge="end"
                    aria-label="next"
                    color="inherit"
                    size="small"
                    onClick={() => onAction(item.id, false)}
                  >
                    <Visibility />
                  </IconButton>
                </CustomTooltip>
                {isMapPage && (
                  <CustomTooltip title={t('components.pop_up.open_pop-up')}>
                    <IconButton
                      edge="end"
                      aria-label="next"
                      color="inherit"
                      size="small"
                      onClick={() =>
                        window.map.addPopup(
                          item,
                          params.location
                            .split(';')[0]
                            .split(',')
                            .map(l => Number.parseFloat(l))
                            .reverse(),
                        )
                      }
                    >
                      <OpenInNew />
                    </IconButton>
                  </CustomTooltip>
                )}
              </Stack>
            }
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                paddingRight: '10px',
                marginTop: splitCols ? '4px' : null,
              }}
            >
              <AssetIcon status={item.status} />
            </ListItemIcon>
            <ListItemText
              primary={item.name}
              primaryTypographyProps={{
                variant: 'body1',
                fontWeight: 'bold',
                sx: {
                  overflow: 'hidden',
                  wordBreak: 'break-word',
                  overflowWrap: 'break-word',
                  width: '170px',
                },
              }}
              secondary={hideDescription ? '' : item.description}
              secondaryTypographyProps={{
                sx: {
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  overflowWrap: 'break-word',
                  color: null,
                  width: '170px',
                },
              }}
            />
          </ListItem>
        </Grid>
      ))}
    </Grid>
  );
};

LayersList.defaultProps = {
  list: [],
};

LayersList.propTypes = {
  list: PropTypes.array,
  onAction: PropTypes.func.isRequired,
  hideDescription: PropTypes.bool.isRequired,
  splitCols: PropTypes.bool.isRequired,
};

export default LayersList;
